


import React from "react";
import css from "../Modulecss/Home.module.css";

const getPlayerDisplayName = (name) => {
    if (!name) return 'Unknown';
    const parts = name.split(' ');
    return parts[0] || name.substring(0, 10);
};

export default function BotTable({ running, winnAmount }) {
    const imageBase = "https://api.kakaking.in/";
    const gameAmount = running.amount;
    const prizeAmount = gameAmount + winnAmount(gameAmount);

    return (
        <>
            <style>
                {`
                    @keyframes slideInLeft {
                        0% { transform: translateX(-100%); opacity: 0; }
                        100% { transform: translateX(0); opacity: 1; }
                    }

                    .running-card-premium {
                        animation: slideInLeft 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
                        background: url('/images/test.avif') no-repeat center center;
                        background-size: cover;
                        border: 1px solid #1e252e;
                        border-radius: 8px;
                        margin-bottom: 10px;
                        overflow: hidden;
                        position: relative;
                        font-family: 'Inter', sans-serif;
                        width: 100%;
                        min-height: 85px;
                    }

                    /* Geometric pattern overlay */
                    .running-card-premium::before {
                        content: "";
                        position: absolute;
                        top: 0; right: 0;
                        width: 60px; height: 60px;
                        background: linear-gradient(135deg, transparent 60%, rgba(255,255,255,0.05) 40%);
                        z-index: 0;
                    }

                    .card-header-premium {
                        padding: 6px 14px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        border-bottom: 1.5px solid rgba(255,255,255,0.1);
                        position: relative;
                        z-index: 1;
                        background: rgba(0,0,0,0.2);
                    }

                    .header-label {
                        color: #ffffff;
                        font-size: 12px;
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                    }

                    .header-value {
                        color: #76ff03; /* Neon green accent */
                        font-weight: 800;
                        margin-left: 5px;
                        display: flex;
                        align-items: center;
                    }

                    .card-body-premium {
                        display: grid;
                        grid-template-columns: 1fr 0.4fr 1fr;
                        padding: 10px 14px;
                        align-items: center;
                        position: relative;
                        z-index: 1;
                    }

                    .player-box {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }

                    .player-box.right {
                        flex-direction: row-reverse;
                        text-align: right;
                    }

                    .avatar-circle {
                        width: 38px;
                        height: 38px;
                        border-radius: 50%;
                        border: 2px solid #76ff03;
                        object-fit: cover;
                        background: #1e252e;
                        box-shadow: 0 0 10px rgba(118, 255, 3, 0.2);
                    }

                    .player-info {
                        display: flex;
                        flex-direction: column;
                    }

                    .player-name-text {
                        color: #ffffff;
                        font-size: 13px;
                        font-weight: 700;
                        letter-spacing: 0.3px;
                    }

                    .vs-center-box {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .vs-icon {
                        width: 32px;
                        filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.5));
                        animation: pulse 1.5s infinite;
                    }

                    @keyframes pulse {
                        0% { transform: scale(1); opacity: 0.8; }
                        50% { transform: scale(1.1); opacity: 1; }
                        100% { transform: scale(1); opacity: 0.8; }
                    }

                    .coin-small {
                        width: 14px;
                        height: 14px;
                        margin-right: 3px;
                    }
                `}
            </style>

            <div className="running-card-premium">
                {/* Header Row - Playing For & Prize */}
                <div className="card-header-premium">
                    <div className="header-label">
                        PLAYING FOR:
                        <span className="header-value">
                            <img src="/images/indiarupee.png" className="coin-small" alt="coin" />
                            {gameAmount}
                        </span>
                    </div>
                    <div className="header-label">
                        PRIZE:
                        <span className="header-value" >
                            <img src="/images/indiarupee.png" className="coin-small" alt="coin" />
                            {prizeAmount}
                        </span>
                    </div>
                </div>

                {/* Main Content: Player 1 vs Player 2 */}
                <div className="card-body-premium">
                    {/* Player 1 Left */}
                    <div className="player-box">
                        <img
                            src={`${imageBase}${running.avatar}`}
                            alt="P1"
                            className="avatar-circle"
                            onError={(e) => (e.target.src = "/images/avatars/Avatar2.png")}
                        />
                        <div className="player-info">
                            <span className="player-name-text">{getPlayerDisplayName(running.name1)}</span>
                        </div>
                    </div>

                    {/* VS Middle with Pulse Animation */}
                    <div className="vs-center-box">
                        <img
                            src='/images/VS.png'
                            className='vs-icon'
                            alt="vs"
                        />
                    </div>

                    {/* Player 2 Right */}
                    <div className="player-box right">
                        <img
                            src={`${imageBase}${running.avatar}`}
                            alt="P2"
                            className="avatar-circle"
                            onError={(e) => (e.target.src = "/images/avatars/Avatar3.png")}
                        />
                        <div className="player-info">
                            <span className="player-name-text">{getPlayerDisplayName(running.name2)}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}